module.exports = __webpack_public_path__ + "img/hover_icon_visit_registry.74a17d60.svg";